import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { theme, cardStyle, inputStyle, btnStyle, labelStyle, tdStyle, thStyle, statCard } from '../theme';

const PackagesPage = ({ API_BASE, patientsList }) => {
  const [tab, setTab] = useState('templates');
  const [packages, setPackages] = useState([]);
  const [patientPkgs, setPatientPkgs] = useState([]);
  const [form, setForm] = useState({ name:'', description:'', price:'', validityDays:365, items:[{ treatmentName:'', quantity:1 }] });
  const [editing, setEditing] = useState(null);
  const [sellForm, setSellForm] = useState({ patientId:'', packageId:'', pricePaid:'' });
  const [selPatientId, setSelPatientId] = useState('');

  const fetchAll = async () => {
    try { const r = await axios.get(`${API_BASE}/packages?active=true`); setPackages(r.data); } catch(e){}
  };

  const fetchPatientPkgs = async (pid) => {
    if (!pid) { setPatientPkgs([]); return; }
    try { const r = await axios.get(`${API_BASE}/packages/patient/${pid}`); setPatientPkgs(r.data); } catch(e){}
  };

  useEffect(() => { fetchAll(); }, []); // eslint-disable-line

  const addItem = () => setForm({...form, items:[...form.items, { treatmentName:'', quantity:1 }]});
  const removeItem = (i) => setForm({...form, items: form.items.filter((_,idx)=>idx!==i)});
  const updateItem = (i, field, val) => {
    const items = [...form.items];
    items[i] = {...items[i], [field]: val};
    setForm({...form, items});
  };

  const handleSave = async () => {
    if (!form.name.trim() || !form.price) return alert('Name and price required');
    try {
      const data = { ...form, price: Number(form.price), validityDays: Number(form.validityDays), items: form.items.filter(i=>i.treatmentName.trim()) };
      if (editing) await axios.put(`${API_BASE}/packages/${editing._id}`, data);
      else         await axios.post(`${API_BASE}/packages`, data);
      setForm({ name:'', description:'', price:'', validityDays:365, items:[{ treatmentName:'', quantity:1 }] });
      setEditing(null); setTab('templates'); fetchAll();
    } catch(e){ alert('Save failed'); }
  };

  const handleSell = async () => {
    if (!sellForm.patientId || !sellForm.packageId) return alert('Select patient and package');
    try {
      const pkg = packages.find(p=>p._id===sellForm.packageId);
      await axios.post(`${API_BASE}/packages/sell`, { ...sellForm, pricePaid: Number(sellForm.pricePaid) || pkg?.price || 0 });
      setSellForm({ patientId:'', packageId:'', pricePaid:'' });
      setTab('templates'); fetchAll();
      alert('Package sold successfully!');
    } catch(e){ alert('Sell failed'); }
  };

  const handleUse = async (ppId, treatmentName) => {
    try {
      await axios.post(`${API_BASE}/packages/use/${ppId}`, { treatmentName });
      fetchPatientPkgs(selPatientId);
    } catch(e){ alert(e.response?.data?.error || 'Usage failed'); }
  };

  const fmtDate = d => d ? new Date(d).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'}) : '—';
  const fmtINR  = n => `₹${(n||0).toLocaleString('en-IN')}`;

  const tabBtn = (key, label) => (
    <button onClick={()=>setTab(key)}
      style={{padding:'9px 20px', borderRadius:'8px', border:'none', cursor:'pointer', fontWeight:'600', fontSize:'0.86rem',
        backgroundColor: tab===key ? theme.primary : '#e9ecef', color: tab===key ? 'white' : '#555'}}>
      {label}
    </button>
  );

  return (
    <div>
      <div style={{display:'flex', gap:'8px', marginBottom:'20px', flexWrap:'wrap'}}>
        {tabBtn('templates', 'Package Templates')}
        {tabBtn('create', editing ? 'Edit Package' : '+ Create Package')}
        {tabBtn('sell', 'Sell to Patient')}
        {tabBtn('usage', 'Patient Usage')}
      </div>

      {/* Templates List */}
      {tab === 'templates' && (
        <div style={cardStyle}>
          <h3 style={{margin:'0 0 16px', color:theme.navy}}>Membership Packages</h3>
          {packages.length === 0 ? <p style={{color:'#aaa'}}>No packages created yet</p> : (
            <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:'16px'}}>
              {packages.map(pkg => (
                <div key={pkg._id} style={{...cardStyle, borderTop:`4px solid ${theme.primary}`, padding:'18px'}}>
                  <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'10px'}}>
                    <div>
                      <h4 style={{margin:'0 0 4px', color:theme.navy}}>{pkg.name}</h4>
                      {pkg.description && <p style={{margin:0, fontSize:'0.82rem', color:theme.textMuted}}>{pkg.description}</p>}
                    </div>
                    <h3 style={{margin:0, color:theme.success}}>{fmtINR(pkg.price)}</h3>
                  </div>
                  <p style={{fontSize:'0.78rem', color:theme.textMuted, margin:'0 0 10px'}}>Validity: {pkg.validityDays} days</p>
                  <div style={{display:'flex', flexDirection:'column', gap:'4px', marginBottom:'12px'}}>
                    {pkg.items.map((item, i) => (
                      <div key={i} style={{display:'flex', justifyContent:'space-between', fontSize:'0.85rem', padding:'4px 8px', backgroundColor:'#f8f9fa', borderRadius:'6px'}}>
                        <span>{item.treatmentName}</span>
                        <span style={{color:theme.textMuted, fontWeight:'600'}}>{item.quantity === -1 ? 'Unlimited' : `× ${item.quantity}`}</span>
                      </div>
                    ))}
                  </div>
                  <button onClick={()=>{setEditing(pkg); setForm({name:pkg.name, description:pkg.description||'', price:pkg.price, validityDays:pkg.validityDays||365, items:pkg.items.length?pkg.items:[{treatmentName:'',quantity:1}]}); setTab('create');}}
                    style={{padding:'5px 14px', backgroundColor:'#0582ca', color:'white', border:'none', borderRadius:'6px', cursor:'pointer', fontSize:'0.78rem', fontWeight:'600'}}>
                    Edit
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Create/Edit */}
      {tab === 'create' && (
        <div style={{...cardStyle, borderTop:`4px solid ${theme.success}`}}>
          <h3 style={{margin:'0 0 16px', color:theme.navy}}>{editing ? 'Edit Package' : 'Create Package'}</h3>
          <div style={{display:'grid', gridTemplateColumns:'2fr 1fr 1fr', gap:'12px', marginBottom:'14px'}}>
            <div><label style={labelStyle}>Package Name *</label><input value={form.name} onChange={e=>setForm({...form, name:e.target.value})} style={inputStyle}/></div>
            <div><label style={labelStyle}>Price ₹ *</label><input type="number" value={form.price} onChange={e=>setForm({...form, price:e.target.value})} style={inputStyle}/></div>
            <div><label style={labelStyle}>Validity (days)</label><input type="number" value={form.validityDays} onChange={e=>setForm({...form, validityDays:e.target.value})} style={inputStyle}/></div>
            <div style={{gridColumn:'span 3'}}><label style={labelStyle}>Description</label><input value={form.description} onChange={e=>setForm({...form, description:e.target.value})} style={inputStyle}/></div>
          </div>
          <label style={labelStyle}>Included Treatments</label>
          {form.items.map((item, i) => (
            <div key={i} style={{display:'flex', gap:'10px', marginBottom:'8px', alignItems:'center'}}>
              <input value={item.treatmentName} onChange={e=>updateItem(i,'treatmentName',e.target.value)} placeholder="Treatment name" style={{...inputStyle, flex:2}}/>
              <input type="number" value={item.quantity} onChange={e=>updateItem(i,'quantity',Number(e.target.value))} placeholder="Qty (-1=unlimited)" style={{...inputStyle, flex:1}}/>
              <button onClick={()=>removeItem(i)} style={{padding:'8px 12px', backgroundColor:theme.danger, color:'white', border:'none', borderRadius:'6px', cursor:'pointer', fontWeight:'700'}}>×</button>
            </div>
          ))}
          <button onClick={addItem} style={{...btnStyle, marginTop:'8px', backgroundColor:'#6c757d', padding:'6px 14px', fontSize:'0.82rem'}}>+ Add Treatment</button>
          <div style={{marginTop:'16px', display:'flex', gap:'10px'}}>
            <button onClick={handleSave} style={{...btnStyle, marginTop:0}}>{editing ? 'Update' : 'Create Package'}</button>
            {editing && <button onClick={()=>{setEditing(null); setForm({name:'',description:'',price:'',validityDays:365,items:[{treatmentName:'',quantity:1}]}); setTab('templates');}} style={{...btnStyle, marginTop:0, backgroundColor:'#6c757d'}}>Cancel</button>}
          </div>
        </div>
      )}

      {/* Sell */}
      {tab === 'sell' && (
        <div style={{...cardStyle, borderTop:`4px solid ${theme.info}`}}>
          <h3 style={{margin:'0 0 16px', color:theme.navy}}>Sell Package to Patient</h3>
          <div style={{display:'grid', gridTemplateColumns:'2fr 2fr 1fr', gap:'12px', marginBottom:'14px'}}>
            <div>
              <label style={labelStyle}>Patient *</label>
              <select value={sellForm.patientId} onChange={e=>setSellForm({...sellForm, patientId:e.target.value})} style={inputStyle}>
                <option value="">Select patient...</option>
                {patientsList.map(p => <option key={p._id} value={p._id}>{p.name} ({p.phone})</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Package *</label>
              <select value={sellForm.packageId} onChange={e=>{
                const pkg = packages.find(p=>p._id===e.target.value);
                setSellForm({...sellForm, packageId:e.target.value, pricePaid: pkg?.price || ''});
              }} style={inputStyle}>
                <option value="">Select package...</option>
                {packages.map(p => <option key={p._id} value={p._id}>{p.name} — {fmtINR(p.price)}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Price Paid ₹</label>
              <input type="number" value={sellForm.pricePaid} onChange={e=>setSellForm({...sellForm, pricePaid:e.target.value})} style={inputStyle}/>
            </div>
          </div>
          <button onClick={handleSell} style={{...btnStyle, marginTop:0, backgroundColor:theme.success}}>Sell Package</button>
        </div>
      )}

      {/* Usage */}
      {tab === 'usage' && (
        <div style={cardStyle}>
          <h3 style={{margin:'0 0 14px', color:theme.navy}}>Patient Package Usage</h3>
          <div style={{display:'flex', gap:'10px', marginBottom:'16px'}}>
            <select value={selPatientId} onChange={e=>{setSelPatientId(e.target.value); fetchPatientPkgs(e.target.value);}} style={{...inputStyle, maxWidth:'400px'}}>
              <option value="">Select patient...</option>
              {patientsList.map(p => <option key={p._id} value={p._id}>{p.name} ({p.phone})</option>)}
            </select>
          </div>
          {patientPkgs.length === 0 ? <p style={{color:'#aaa'}}>No packages for this patient</p> : (
            patientPkgs.map(pp => (
              <div key={pp._id} style={{...cardStyle, marginBottom:'14px', borderLeft:`4px solid ${pp.status==='active'?theme.success:theme.textMuted}`, padding:'18px'}}>
                <div style={{display:'flex', justifyContent:'space-between', marginBottom:'10px'}}>
                  <div>
                    <h4 style={{margin:'0 0 4px', color:theme.navy}}>{pp.packageName}</h4>
                    <div style={{fontSize:'0.82rem', color:theme.textMuted}}>
                      Purchased: {fmtDate(pp.purchaseDate)} • Expires: {fmtDate(pp.expiryDate)} • Paid: {fmtINR(pp.pricePaid)}
                    </div>
                  </div>
                  <span style={{padding:'4px 12px', borderRadius:'12px', fontSize:'0.78rem', fontWeight:'700',
                    backgroundColor: pp.status==='active'?'#d1fae5':'#e5e7eb',
                    color: pp.status==='active'?'#065f46':'#374151'}}>
                    {pp.status}
                  </span>
                </div>
                <table style={{width:'100%', borderCollapse:'collapse'}}>
                  <thead><tr><th style={thStyle}>Treatment</th><th style={thStyle}>Allowed</th><th style={thStyle}>Used</th><th style={thStyle}>Remaining</th><th style={thStyle}></th></tr></thead>
                  <tbody>
                    {(pp.usage||[]).map((u, i) => {
                      const remaining = u.allowed === -1 ? '∞' : (u.allowed - u.used);
                      const canUse = pp.status === 'active' && (u.allowed === -1 || u.used < u.allowed);
                      return (
                        <tr key={i}>
                          <td style={tdStyle}>{u.treatmentName}</td>
                          <td style={tdStyle}>{u.allowed === -1 ? 'Unlimited' : u.allowed}</td>
                          <td style={tdStyle}>{u.used}</td>
                          <td style={{...tdStyle, fontWeight:'700', color: remaining === 0 ? theme.danger : theme.success}}>{remaining}</td>
                          <td style={tdStyle}>
                            {canUse && <button onClick={()=>handleUse(pp._id, u.treatmentName)}
                              style={{padding:'4px 10px', backgroundColor:theme.primary, color:'white', border:'none', borderRadius:'6px', cursor:'pointer', fontSize:'0.74rem', fontWeight:'600'}}>
                              Use 1
                            </button>}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default PackagesPage;
